import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import HowQorvixWorks from './pages/HowQorvixWorks';
import AboutPage from './pages/AboutPage';
import PortfolioPage from './pages/PortfolioPage';
import FAQPage from './pages/FAQPage';
import RoadmapPage from './pages/RoadmapPage';
import IntegrationsPage from './pages/IntegrationsPage';
import DocumentationPage from './pages/DocumentationPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ContactPage from './pages/ContactPage';
import QualificationFunnelPage from './pages/QualificationFunnelPage.jsx';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

function MetaPixelRouteTracker() {
    const location = useLocation();
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    }, [location.pathname, location.search]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <MetaPixelRouteTracker />
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/how-it-works" element={<HowQorvixWorks />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/roadmap" element={<RoadmapPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                <Route path="/documentation" element={<DocumentationPage />} />
                <Route path="/help-center" element={<HelpCenterPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/apply" element={<QualificationFunnelPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;